import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { toast } from 'sonner';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { completeOAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || '';
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate('/login', { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    completeOAuth(session_id)
      .then((user) => {
        toast.success(`Welcome, ${user.name || user.email}`);
        window.history.replaceState({}, document.title, '/dashboard');
        navigate('/dashboard', { replace: true, state: { user } });
      })
      .catch((e) => {
        toast.error(e?.response?.data?.detail || 'Sign-in failed');
        navigate('/login', { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- one-shot OAuth exchange; intentionally runs on mount only
  }, []);

  return (
    <div className="min-h-[60vh] grid place-items-center text-white/60">
      <div className="flex flex-col items-center gap-3">
        <div className="h-10 w-10 rounded-full border-2 border-[#FF6B1A]/40 border-t-[#FF6B1A] animate-spin" />
        <div className="text-sm">Finalizing sign-in…</div>
      </div>
    </div>
  );
}
